import * as zod from "zod";

export const menuApprovalFormSchema = zod.object({
  id: zod.number(),
  type: zod.string(),
  approve: zod.boolean(),
  userId: zod.number(),
  rejectReason:zod.string()
});

export type MenuApprovalFormSchemaFormValuesType = zod.infer<typeof menuApprovalFormSchema>;

export const menuApprovalInitialValues: MenuApprovalFormSchemaFormValuesType = {
  id: 0,
  type: "",
  approve: true,
  userId: 0,
  rejectReason:"",
};
